export const COLORS = {
  bg: {
    "1": "#ffffff",
    "2": "#F2F2F2",
    "3": "#E8E8E8",
    "4": "#CCCCCC",
    "5": "#A6A6A6",
    "6": "#404040",
    "7": "#000000",
  },
  fg: {
    "1": "#000000",
    "2": "#757575",
    "3": "#A6A6A6",
    "4": "#CCCCCC",
    primary: "#B47BFF",
    inverse: "#ffffff",
  },
  primary: {
    "1": "#F0E5FE",
    "2": "#DABDFF",
    "3": "#B47BFF",
    "4": "#9C52FD",
    "5": "#640AD9",
    "6": "#4E00B2",
  },
  secondary: {
    default: "#FF5CE9",
    light: "#FEEAF4",
    dark: "#FF1FE1",
  },
  green: {
    light: "#E5F8E5",
    default: "#54CF52",
    dark: "#1C821A",
  },
  yellow: "#FFDB1E",
  red: {
    dark: "#B23722",
    default: "#FE4F30",
    light: "#FFE5E0",
  },
  gold: {
    light: "#DFAE80",
    default: "#916B47",
    dark: "#B97E47",
  },
  transparent: "transparent",
}

type MaxDepth = 3
type Increment<N extends number> = N extends 1 ? 2 : N extends 2 ? 3 : never

type FlattenKeys<T, Depth extends number = 1> = Depth extends MaxDepth
  ? never
  : T extends object
    ? {
        [K in keyof T]: K extends string
          ? T[K] extends object
            ? `${K}` | `${K}-${FlattenKeys<T[K], Increment<Depth>>}`
            : `${K}`
          : never
      }[keyof T]
    : never

function getFlattenKeys<T extends Record<string, any>>(obj: T): FlattenKeys<T>[] {
  const result: string[] = []

  function helper(subObj: any, prefix: string = "") {
    for (const key in subObj) {
      const newKey = prefix ? `${prefix}${key}` : key
      if (typeof subObj[key] === "object" && subObj[key] !== null) {
        helper(subObj[key], `${newKey}-`)
      } else {
        result.push(newKey)
      }
    }
  }

  helper(obj)
  return result as FlattenKeys<T>[]
}

export type Color = FlattenKeys<typeof COLORS>

export const COLOR_VARIANT_NAMES: Color[] = getFlattenKeys(COLORS)

export type TextColor = `text-${Color}`
export type BgColor = `bg-${Color}`
export type StrokeColor = `stroke-${Color}`
export type FillColor = `fill-${Color}`

export function getHex(color: Color): string | undefined {
  const keys = color.split("-")
  let current: any = COLORS

  for (const key of keys) {
    if (current[key] !== undefined) {
      current = current[key]
    } else {
      return undefined
    }
  }

  if (typeof current === "string") {
    return current
  }
  return undefined
}
